<template>
  <div class="mt-3">
    <div class="width-100 text-center">
      <font-awesome-icon icon="check-circle" size="lg" class="success-icon" />
    </div>

    <p class="text-center mt-3 mb-3">
      Congratulations! Your account is all set up.
    </p>

    <div class="form-group mb-0 text-center">
      <button class="btn btn-primary btn-block" type="button" @click="onContinueClick">
        Get Started!
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AccountReady',
  components: {
  },

  data() {
    return {
    };
  },

  computed: {
  },

  methods: {

    onContinueClick() {
      this.$emit('getstarted');
    },
  },
};
</script>

<style lang="scss" scoped>

.success-icon {
  font-size: 6rem;
  color: $purple;
}

</style>
